import {
    Search,
    X,
} from "lucide-react";

function AdminUserFilters({
    filters,
    onChange,
}) {

    const clearFilters = () => {

        onChange("search", "");
        onChange("status", "");

    };

    return (

        <div className="admin-users-filters">

            <div className="search-box">

                <Search size={18} />

                <input
                    type="text"
                    placeholder="Search admin..."
                    value={filters.search}
                    onChange={(e) =>
                        onChange("search", e.target.value)
                    }
                />

            </div>

            <select
                value={filters.status}
                onChange={(e) =>
                    onChange("status", e.target.value)
                }
            >

                <option value="">
                    All Status
                </option>

                <option value="Active">
                    Active
                </option>

                <option value="Inactive">
                    Inactive
                </option>

            </select>

            <button
                className="clear-btn"
                onClick={clearFilters}
            >

                <X size={18} />

                Clear

            </button>

        </div>

    );

}

export default AdminUserFilters;